import Axios from "./Axios"
import { onlineClassId } from "@/utils/getWebserver"
import { SENSORLOG } from "@/constants"
import sensorLog from "@/utils/sensorLog"
import { env } from "@/config/index"
export default {
  fetchWebserverData: async param => {
    // 获取信令信息
    sensorLog.track("fetch_webserver", SENSORLOG.type.INIT)
    try {
      return await Axios.get(param)
    } catch (error) {
      throw new Error(
        "fetchWebserverData api is failed,error code is :" + error
      )
    }
  },
  updateRoomStatus: async () => {
    // 下课
    sensorLog.track("update_room_state", SENSORLOG.type.INIT)
    try {
      return await Axios.get(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/classroom/teacher/endroom`
      )
    } catch (error) {
      throw new Error("updateRoomStatus api is failed,error code is :" + error)
    }
  },
  getVideoList: param => {
    // 获取课中视频列表
    sensorLog.track("get_video_list", SENSORLOG.type.INIT)
    let { lessonId } = param
    if (lessonId) {
      return Axios.get(
        `/api/vps/service/openclass/gw/pc/classroom/teacher/getvideolistbylessonid?lessonId=${lessonId}`
      )
    } else {
      return Axios.get(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/classroom/teacher/getvideolist`
      )
    }
  },
  getServerTime: () => {
    // 获取当前服务时间
    sensorLog.track("get_server_time", SENSORLOG.type.INIT)
    return Axios.get("/api/vps/service/openclass/gw/pc/getnowtime")
  },
  fetchEnterRoomParams: async () => {
    // 获取房间详细
    sensorLog.track("check_room_type", SENSORLOG.type.INIT)
    try {
      return await Axios.get(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/classroom/teacher/enterroom`
      )
    } catch (error) {
      throw new Error(
        "fetchEnterRoomParams api is failed,error code is :" + error
      )
    }
  },
  updateClassLine: async param => {
    // 切线
    sensorLog.track("update_room_type", SENSORLOG.type.INIT)
    let url = ""
    if (env === "test" || env === "stage") {
      url = "/api/vps/service/openclass/liverelay/v1/room/settype"
    } else if (env === "pre") {
      url =
        "https://pre-openclass-liverelay.vipkid.com.cn/api/vps/service/openclass/liverelay/v1/room/settype"
    } else {
      url =
        "https://openclass-liverelay.vipkid.com.cn/api/vps/service/openclass/liverelay/v1/room/settype"
    }
    try {
      return await Axios.get(url, param)
    } catch (error) {
      throw new Error("updateClassLine api is failed,error code is :" + error)
    }
  },
  fetchGiftData: async () => {
    // 获取可用红包
    sensorLog.track("get_gift_data", SENSORLOG.type.INIT)
    try {
      return await Axios.get(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/gift/info?giftType=1`
      )
    } catch (error) {
      throw new Error("fetchGiftData api is failed,error code is :" + error)
    }
  },
  updataGiftData: async ({ giftSn }) => {
    // 发红包
    sensorLog.track("update_gift_data", SENSORLOG.type.INIT)
    try {
      return await Axios.post(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/gift/update`,
        {
          giftType: 1,
          giftSn
        }
      )
    } catch (error) {
      throw new Error("updataGiftData api is failed,error code is :" + error)
    }
  },
  getStudentGiftNum: async ({ giftSn }) => {
    // 学生领取红包数
    sensorLog.track("get_student_gift_num", SENSORLOG.type.INIT)
    try {
      return await Axios.get(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/gift/studentlist?giftType=1&giftSn=${giftSn}&count=10`
      )
    } catch (error) {
      throw new Error("getStudentGiftNum api is failed,error code is :" + error)
    }
  },
  updateQuestioninfo: async ({ questionList }) => {
    // 所有答题数据
    sensorLog.track("update_questioninfo", SENSORLOG.type.INIT)
    try {
      return await Axios.post(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/qa/teacher/questioninfo`,
        {
          questionList
        }
      )
    } catch (error) {
      throw new Error(
        "updateQuestioninfo api is failed,error code is :" + error
      )
    }
  },
  updateQuestionTime: async () => {
    // 答题结束上报
    sensorLog.track("update_questiontime", SENSORLOG.type.INIT)
    try {
      return await Axios.post(
        `/api/vps/service/openclass/gw/pc/${onlineClassId}/qa/teacher/gather`
      )
    } catch (error) {
      throw new Error(
        "updateQuestioninfo api is failed,error code is :" + error
      )
    }
  }
}
